import { tplOf, positionName } from "../../lib/shield";

const chip = (on) => `min-w-[3.25rem] border-2 px-2.5 py-2 text-xs font-extrabold uppercase tracking-wide transition-colors ${on ? "border-slate-900 bg-slate-900 text-lime-300" : "border-slate-200 bg-white text-slate-800 hover:border-slate-900"}`;

export const PositionPicker = ({ player, sport, set, inputCls }) => {
  const opts = [["", "None", "No position"], ...tplOf(sport).positions.map((p) => [p, p, positionName(p, sport)]), ["custom", "Custom", "Type your own"]];
  return (
    <div data-testid="player-position-picker">
      <div className="text-sm font-bold">Playing position</div>
      <div className="mt-1 flex flex-wrap gap-1.5" role="radiogroup" aria-label="Playing position">
        {opts.map(([v, label, title]) => (
          <button key={v || "none"} type="button" role="radio" aria-checked={player.position === v} title={title} onClick={() => set({ position: v })}
            className={chip(player.position === v)} data-testid={`position-option-${v || "none"}`}>{label}</button>
        ))}
      </div>
      {player.position && player.position !== "custom" && <p className="mt-1 text-xs text-slate-500" data-testid="position-full-name">{positionName(player.position, sport)}</p>}
      {player.position === "custom" && (
        <input value={player.customPosition} maxLength={6} autoFocus onChange={(e) => set({ customPosition: e.target.value.toUpperCase() })}
          placeholder="e.g. SUB" className={inputCls} data-testid="player-custom-position-input" />
      )}
    </div>
  );
};
